import * as React from "react";

function IconGridDots({
  size = 24,
  color = "currentColor",
  stroke = 2,
  ...props
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-grid-dots" width={size} height={size} viewBox="0 0 24 24" strokeWidth={stroke} stroke={color} fill="none" strokeLinecap="round" strokeLinejoin="round" {...props}><desc>{"Download more icon variants from https://tabler-icons.io/i/grid-dots"}</desc><path stroke="none" d="M0 0h24v24H0z" fill="none" /><circle cx={5} cy={5} r={1} /><circle cx={12} cy={5} r={1} /><circle cx={19} cy={5} r={1} /><circle cx={5} cy={12} r={1} /><circle cx={12} cy={12} r={1} /><circle cx={19} cy={12} r={1} /><circle cx={5} cy={19} r={1} /><circle cx={12} cy={19} r={1} /><circle cx={19} cy={19} r={1} /></svg>;
}

export default IconGridDots;